import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaApple, FaGoogle } from 'react-icons/fa';
import professionalIcon from '../../assets/icons/professional-register.svg';
import empreendimentoIcon from '../../assets/icons/empreendimento-register.svg';
import ProfessionalForm from './ProfessionalForm';
import EmpreendimentoForm from './EmpreendimentoForm';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Modal from '../../components/Modal';
import registerImage from '../../assets/backgrounds/register.png';
import './styles.css';

const Register = () => { 
  const [showProfessional, setShowProfessional] = useState(false);
  const [showEmpreendimento, setShowEmpreendimento] = useState(false);
  const { handleOpenLogin } = useGlobalState();
 
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  useEffect(() => {
    document.body.classList.add('register-page');
    return () => {
      document.body.classList.remove('register-page');
    };
  }, []);

  const handleTermsClick = (e) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setShowPrivacyModal(true);
  };
 
  if (showProfessional) {
    return <ProfessionalForm onBack={() => setShowProfessional(false)} />;
  }
  if (showEmpreendimento) {
    return <EmpreendimentoForm onBack={() => setShowEmpreendimento(false)} />;
  }
 
  return (
    <>
      <Header />
      <section className="register-section">
        <div className="register-container">
          <div className="register-content">
            <div className="register-left">
              <div className="register-form-container">
                <div className="social-login">
                  <Link to="#" className="social-button facebook">
                    <FaFacebook /> <span>Continuar com o Facebook</span>
                  </Link>
                  <Link to="#" className="social-button apple">
                    <FaApple /> <span>Continuar com a Apple</span>
                  </Link>
                  <Link to="#" className="social-button google" onClick={(e) => { e.preventDefault(); handleOpenLogin?.(); }}>
                    <FaGoogle /> <span>Continuar com o Google</span>
                  </Link>
                </div>

                <form className="register-form">
                  <div className="register-extra-buttons">
 
                  </div>
                  <div className="form-group">
                    <input 
                      type="text" 
                      placeholder="Nome completo"
                      className="form-input"
                      autoComplete="off"
                    />
                  </div>

                  <div className="form-group">
                    <input 
                      type="email" 
                      placeholder="Email"
                      className="form-input"
                      autoComplete="off"
                    />
                  </div>

                  <div className="form-group password-group">
                    <input 
                      type={showPassword ? "text" : "password"}
                      placeholder="Password" 
                      className="form-input"
                    />
                    <button 
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </button>
                  </div>

                  <div className="form-group password-group">
                    <input 
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirmar password" 
                      className="form-input"
                    />
                    <button 
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </button>
                  </div>

                  <div className="terms-check">
                    <label>
                      <input type="checkbox" />
                      <span>
                        Aceito os <a href="#" onClick={handleTermsClick}>Termos e Condições</a> e a <a href="#" onClick={handlePrivacyClick}>Política de Privacidade</a>
                      </span>
                    </label>
                  </div>

                  <button type="submit" className="submit-button">
                    Criar conta
                  </button>
                </form>

                <div className="register-footer">
                  <p>
                    Já tem uma conta? <Link to="/login">Entrar</Link>
                  </p>
                </div>
              </div>
            </div>

            <div className="register-right">
              <div className="register-info">
                <h2>Milhões de compradores e vendedores confiam em nós</h2>
                <ul className="benefits-list">
                  <li>Uma das maiores plataformas imobiliárias em Portugal</li>
                  <li>Mais de 6 milhões de visitas por mês</li>
                  <li>Mais de 250 mil anúncios ativos por mês</li>
                  <li>Ferramentas para ajudar a alcançar os seus objetivos</li>
                </ul>
              </div>
              <img src={registerImage} alt="Register" className="register-image" />
            </div>
          </div>
        </div>
      </section>

      <Modal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
        title="Termos e Condições"
      >
        <div className="terms-content">
          <h3>1. Aceitação dos Termos</h3>
          <p>Ao acessar e usar o JoviPlanet, você concorda em cumprir estes termos e condições. Se você não concordar com qualquer parte destes termos, não poderá usar nossos serviços.</p>

          <h3>2. Uso do Serviço</h3>
          <p>Nosso serviço permite que você encontre, liste e gerencie propriedades para aluguel. Você concorda em usar o serviço apenas para fins legais e de acordo com estes termos.</p>

          <h3>3. Conta de Usuário</h3>
          <p>Para usar alguns recursos do nosso serviço, você precisará criar uma conta. Você é responsável por manter a confidencialidade de sua conta e senha.</p>

          <h3>4. Conteúdo do Usuário</h3>
          <p>Ao publicar conteúdo em nossa plataforma, você garante que tem os direitos necessários sobre esse conteúdo e que ele não viola direitos de terceiros.</p>

          <h3>5. Responsabilidades</h3>
          <p>A JoviPlanet não é responsável por quaisquer danos diretos, indiretos, incidentais ou consequentes resultantes do uso ou incapacidade de usar nossos serviços.</p>
        </div>
      </Modal>

      <Modal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        title="Política de Privacidade"
      >
        <div className="privacy-content">
          <h3>1. Coleta de Dados</h3>
          <p>Coletamos informações que você nos fornece diretamente ao usar nossos serviços, incluindo dados de registro, informações de perfil e conteúdo que você publica.</p>

          <h3>2. Uso de Dados</h3>
          <p>Usamos suas informações para fornecer, manter e melhorar nossos serviços, bem como para personalizar sua experiência na plataforma.</p>

          <h3>3. Compartilhamento de Dados</h3>
          <p>Não vendemos suas informações pessoais. Compartilhamos dados apenas conforme necessário para fornecer nossos serviços ou conforme exigido por lei.</p>

          <h3>4. Segurança</h3>
          <p>Implementamos medidas de segurança para proteger suas informações contra acesso não autorizado ou alteração.</p>

          <h3>5. Seus Direitos</h3>
          <p>Você tem o direito de acessar, corrigir ou excluir suas informações pessoais a qualquer momento.</p>
        </div>
      </Modal>

   
    </>
  );
};

export default Register; 